<div class="news-shell">
    <div class="news-card">
        <div class="news-title">Ultimas noticias</div>
        <div class="news-subtitle">Aqui encontraras las ultimas noticias de Happymile en tu ciudad o anuncios nacionales.</div>

        <div class="news-grid">
            <div class="news-col">
                <div class="news-line news-line--blue"></div>
                <div class="news-label news-label--blue">Actualizaciones de industria</div>
                <div class="news-text">
                    Proximamente...
                </div>
            </div>
            <div class="news-col">
                <div class="news-line news-line--pink"></div>
                <div class="news-label news-label--pink">Costos de operacion</div>
                <div class="news-text">
                    Proximamente...
                </div>
            </div>
            <div class="news-col">
                <div class="news-line news-line--blue"></div>
                <div class="news-label news-label--blue">Personas y cultura</div>
                <div class="news-text">
                    Proximamente...
                </div>
            </div>
        </div>

        <button pButton label="Ver mas" class="p-button-rounded p-button-info mt-4 font-bold px-4 w-max"
                (click)="showComingSoon()"></button>
    </div>
</div>
